import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const HittaElbolag = lazy(() => import("@/pages/verktyg/HittaElbolag"));

export const Route = createFileRoute("/verktyg/hitta-elbolag")({
  head: () => seoHead("/verktyg/hitta-elbolag", { description: "Ta reda på vilket elbolag du har idag och jämför ditt avtal med andra leverantörer. På så sätt ser du om du kan spara pengar eller få bättre villkor." }),
  component: () => <HittaElbolag />,
});
